module.exports = __webpack_public_path__ + "img/四川天府新区第十一幼儿园.a898cb97.jpg";